import { memo, useState, useEffect } from 'react'
import CommonFunc from '@/utils/common-func'
import { UNIT } from '@/utils/global-const'
import { Table, Input } from 'antd'
import './BaseTable.less'
const BaseTable = (props: any) => {
  const [dataSource, setDataSource] = useState([])
  const [columns, setColumns] = useState([])
  useEffect(() => {
    let columnData = props.columns || []
    if (props.type === 'input') {
      columnData.forEach((item: any) => {
        item.render = (text: any, record: any, idx: number) => {
          return (
            <Input
              value={text}
              onChange={e => {
                if (props.ontdChange) {
                  props.ontdChange(e.target.value, idx, item.key)
                }
              }}
            />
          )
        }
      })
      columnData = columnData.map((col: any, index: any) => ({
        ...col,
        title: (
          <>
            {props.trDisabled ? (
              <span className='title'>{col.title}</span>
            ) : (
              <Input
                disabled={props.trDisabled}
                value={col.title}
                onChange={e => {
                  if (props.ontdChange) {
                    props.ontrChange(e.target.value, index)
                  }
                }}
              />
            )}
          </>
        )
      }))
    } else {
      columnData = columnData.map((item: any) => {
        if (item.key === 'created_at') {
          item.render = (text: any) => {
            return <>{CommonFunc.timestampToTime(text, false, 'YYYY-MM-DD hh:mm')}</>
          }
        } else if (item.key === 'type') {
          const TYPR_NAME: any = {
            0: '套餐',
            1: '开题报告',
            2: '文献综述',
            3: '毕业论文',
            4: '课程论文',
            5: '答辩PPT',
            6: '降重',
            7: '降AIGC',
            8: '格式排版'
          }
          item.render = (text: any) => {
            return <>{TYPR_NAME[text]}</>
          }
        } else if (item.key == 'count') {
          item.render = (text: any, record: any) => {
            return (
              <>
                {text}
                {UNIT[record.type]}
              </>
            )
          }
        } else if (item.key == 'price' || item.key == 'unit_price') {
          item.render = (text: any) => {
            return <>{text / 100}</>
          }
        }
        return item
      })
    }
    setDataSource(props.dataSource || [])
    setColumns(columnData || [])
  }, [props.dataSource, props.columns])
  return (
    <div className={`baseTable-container ${props.className}`}>
      <Table
        rowClassName={() => 'editable-row'}
        bordered={props.bordered || false}
        dataSource={dataSource}
        columns={columns}
        pagination={props.pagination || false}
        locale={
          props.locale || {
            emptyText: '暂无数据' // 自定义文本
          }
        }
        {...(props.scroll ? { scroll: props.scroll } : {})} // 只有传了才加 scroll
      />
    </div>
  )
}

export default memo(BaseTable)
